// Copyright (c) 2016 Deere & Company

import React, {Component, PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

/* eslint-disable react/prefer-stateless-function */

class CreateClaimCellRenderer extends Component {

    render() {

        return (
            <div className='create-claim-cell-renderer'>
                <a
                    className='create-claim-link'
                    href={`#/claims/mcc-followup/new/${encodeURI(this.props.value)}`}
                    rel='noopener noreferrer'
                    target='_blank'
                >
                    <FormattedMessage id='CREATE_CLAIM'/>
                </a>
            </div>
        );

    }

}

CreateClaimCellRenderer.displayName = 'CreateClaimCellRenderer';
CreateClaimCellRenderer.propTypes = {
    value: PropTypes.string.isRequired
};

export default CreateClaimCellRenderer;



// WEBPACK FOOTER //
// ./src/reports/shared/report-cell-renderers/create-claim-cell-renderer.js